import React, { useRef, useState, useEffect } from 'react';
import { PlusIcon, TrashIcon, EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import CardRowClassL2 from './CardRowClassL2';
import { getL1Options, getL2Options, buildL0Key, buildL1Key } from '../../../moduleServices/helper_hierarchicalCategory';

const CardBoxClassL1 = ({
  planId,
  l1Category,
  l1Total,
  filteredL2Budgets,
  budgetType,
  onDeleteL1,
  hierarchicalCategories,
  l0Id,
  onItemCreated,
  onItemUpdated,
  onItemDeleted,
  date,
  isVisibleL2 = true,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [addRows, setAddRows] = useState([]);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handler = e => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  function handleAddRowL2() {
    const l1Id = l1Category && typeof l1Category === 'object' ? l1Category.value : l1Category;
    
    const l0Label = hierarchicalCategories.by_l0?.[l0Id]?.name || l0Id;
    const l1Label = hierarchicalCategories.by_l1?.[l1Id]?.name || l1Id;
    
    const newRow = {
      class_l0: l0Label,
      class_l1: l1Label,
      class_l2: '',
      description: '',
      budget_amount: '',
      budget_type: budgetType,
    };
    setAddRows(prev => [...prev, newRow]);
  }

  function handleCancelAddL2(index) {
    setAddRows(prev => prev.filter((_, i) => i !== index));
  }

  function handleItemCreatedRow(b) {
    setAddRows([]);
    onItemCreated && onItemCreated(b);
  }

  return (
    <div className="bg-gray-100 rounded-lg px-2 py-1 mb-1">
      <div className="flex items-center mb-1 relative">
        <span className="font-semibold text-gray-700 text-base">
          {l1Category && typeof l1Category === 'object' ? l1Category.label : l1Category || <span className='font-normal text-gray-400 italic'>No sub-category</span>}
        </span>
        <div className="flex items-center ml-auto gap-1">
          <span className="font-semibold min-w-[100px] text-right mr-2">{l1Total}</span>
          <div className="relative" ref={menuRef}>
            <button
              className="text-gray-500 hover:bg-gray-200 rounded px-1 py-0.5 flex items-center"
              title="Open menu"
              aria-label="Open menu"
              onClick={() => setMenuOpen(x => !x)}
            >
              <EllipsisVerticalIcon className="w-5 h-5" />
            </button>
            {menuOpen && (
              <div className="absolute z-30 right-0 top-full mt-1 bg-white border border-gray-200 rounded shadow-lg p-1 w-max">
                {isVisibleL2 && (
                  <button
                    className="flex items-center gap-2 text-green-700 hover:bg-green-50 px-3 py-1.5 rounded text-sm whitespace-nowrap"
                    onClick={() => { setMenuOpen(false); handleAddRowL2(); }}
                  >
                    <PlusIcon className="w-4 h-4" />Add entry
                  </button>
                )}
                <button
                  className="flex items-center gap-2 text-red-600 hover:bg-red-50 px-3 py-1.5 rounded text-sm whitespace-nowrap"
                  onClick={() => { setMenuOpen(false); onDeleteL1 && onDeleteL1(); }}
                >
                  <TrashIcon className="w-4 h-4" />Delete category
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isVisibleL2 && (
        <div className="flex flex-col gap-1 ml-2 md:ml-3">
          {filteredL2Budgets && typeof filteredL2Budgets === 'object' &&
            Object.entries(filteredL2Budgets).map(([l2, budgets]) =>
              Array.isArray(budgets)
                ? budgets.map((b, idx) => (
                    <CardRowClassL2
                      key={b.id || l2 + '-' + budgetType + '-' + idx}
                      planId={planId}
                      budget={b}
                      isNew={false}
                      hierarchicalCategories={hierarchicalCategories}
                      onItemUpdated={onItemUpdated}
                      onItemDeleted={onItemDeleted}
                      l0Id={l0Id}
                      l1Id={l1Category && typeof l1Category === 'object' ? l1Category.value : l1Category}
                      date={date}
                    />
                ))
                : null
            )
          }
          {addRows.map((b, idx) => (
            <CardRowClassL2
              key={'add-' + (b.class_l1?.value || b.class_l1) + '-' + budgetType + '-' + idx}
              planId={planId}
              budget={b}
              isNew={true}
              index={idx}
              hierarchicalCategories={hierarchicalCategories}
              onCancelAdd={handleCancelAddL2}
              onItemCreated={handleItemCreatedRow}
              l0Id={l0Id}
              l1Id={l1Category && typeof l1Category === 'object' ? l1Category.value : l1Category}
              date={date}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CardBoxClassL1;
